/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import postToUrl from "./mixins/postToUrl";


require('./bootstrap');

import * as Vue from 'vue';
// import Vuelidate from 'vuelidate';

import VuePlyr from "@skjnldsv/vue-plyr";


// require('Modernizr');

import Hls from 'hls.js';
window.hls_is_supported = Hls.isSupported();

import { store } from './data_hub';
import loaderOverlay from './mixins/loaderOverlay';
import userData from "./mixins/ApiHandler";

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))



// Vue.mixin(loaderOverlay);
// Vue.mixin(userData);

// if(Modernizr.cssgrid){
    window.modern_browser = true;
// }

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var emitter = require('tiny-emitter/instance');

const app = Vue.createApp({
    // store: store,
    // mixins: [loaderOverlay, userData],
    data: {
        hls_is_supported: window.hls_is_supported,
	    recipient_count: 1
    },
    created(){
        this.$store.commit('setScreenMode');
        let timer;
        window.addEventListener("resize",()=>{
            if(timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.$store.commit('setScreenMode');
                emitter.emit('windowResized');
            },50);
        });
    },
    mounted()
    {
		const app = this;

        $('#league-select').change(function(e){
            e.preventDefault();
            window.location = $(this).val();
        });

        $('a[data-target="calendar"]').click((e)=>{

			// don't allow calendar modal from library page (easier to avoid sync issues... force page refresh)
	        if(!window.location.href.includes("workout-library") && !window.location.href.includes("quiz"))
			{
		        e.preventDefault();

		        if(!Window.user_is_authorized)
		        {
			        window.location = '/login';
			        return false;
		        }

		        emitter.emit('calendarModalOpening');
	        }
        });

        emitter.on('calendarModalOpening', this.fixBody);
        emitter.on('calendarModalClosed', this.unFixBody);

        $('.card-management-btns button').on('click', function(e){
            e.preventDefault();
            if($(this).hasClass('disabled')){
                return false;
            }

            const form_handle = $(this).data('action') + '-submit-' + $(this).data('index');

            if(confirm('Are you sure?')){
                $('form#' + form_handle).submit();
            }
        });

        $('#cancel-plan-offer').click(function(e){
            e.preventDefault();
            $('form#cancel-plan-offer-submit').submit();
        });

        let self = this;

        $('#cancel-plan-final-confirmation').click(function(e){
            e.preventDefault();

            const comments = $('#reasons-for-cancellation').val();

            self.postToUrl('/account/manage-subscription/cancel-plan-final-confirmation-submit', {
                comments: comments,
            });
        });

        $('#have-registration-code').click(function(e){
            e.preventDefault();

            $('.registration-input').toggle();
        });

        $('#add-cc-field').click(function(e){
            e.preventDefault();

			if(app.recipient_count >= 5){
				return false;
			}
	        app.recipient_count++

            var targetDiv = e.currentTarget.parentElement;

            var div = document.createElement('div');
            div.classList.add('form-row');

	        var button = document.createElement('label');
	        button.innerHTML = '<span>Recipient ' + app.recipient_count + '<br><a href="#" class="small remove-cc-field">click to remove</a></span>';
	        // button.setAttribute('class', 'remove-cc-field');
	        // button.classList.add('standard-button');

	        div.appendChild(button);

	        // var space = document.createElement('span');

	        // space.innerHTML = '&nbsp;';
	        // div.appendChild(space);
            var input = document.createElement('input');

	        input.setAttribute('type', 'text');
	        input.setAttribute('name', 'add_cc[]');
	        input.setAttribute('placeholder', 'name@email.com');
	        input.setAttribute('required', 'required');
            div.appendChild(input);

            targetDiv.insertAdjacentElement('beforebegin', div);

	        if(app.recipient_count >= 5){
		        $('#add-cc-field').hide();
	        }
        });

        $(document).on('click', '.remove-cc-field', function(e) {
            e.preventDefault();
            var divToRemove = e.currentTarget.parentElement.parentElement.parentElement;
	        divToRemove.remove();
	        if(app.recipient_count === 5){
		        $('#add-cc-field').show();
	        }
	        app.recipient_count--;
        });

    },
    methods: {
        fixBody()
        {
            const scrollbarwidth = window.innerWidth - document.documentElement.clientWidth;
            const body = document.body;
            body.style.paddingRight = scrollbarwidth + 'px';
            body.style.overflow = 'hidden';
        },
        unFixBody()
        {
            const body = document.body;
            body.style.paddingRight = 0;
            body.style.overflow = 'auto';
        }
    }
});

app.mixin(userData);
app.mixin(postToUrl);
app.mixin(loaderOverlay);
app.use(store);
// app.use(Vuelidate);
app.use(VuePlyr);

app.component('nav-component', require('./components/NavComponent.vue').default);
app.component('dashboard-user-overview', require('./components/DashboardUserOverview.vue').default);
app.component('skills-lab-builder', require('./components/SkillsLabBuilder').default);
app.component('skills-lab-player', require('./components/SkillsLabPlayer').default);
app.component('skills-lab-player-no-hls-fallback', require('./components/SkillsLabPlayerNoHlsFallback').default);
app.component('chapter-browser', require('./components/ChapterBrowser').default);
app.component('workout-library', require('./components/WorkoutLibrary').default);
app.component('workout-library-filters', require('./components/WorkoutLibraryFiltersComponent').default);
app.component('workout-library-player', require('./components/WorkoutLibraryPlayer').default);
app.component('stripe-component', require('./components/StripeComponent.vue').default);
app.component('add-payment-method-component', require('./components/AddPaymentMethod').default);
app.component('modal-component', require('./components/ModalComponent.vue').default);
app.component('support-video-component', require('./components/SupportVideoComponent').default);
app.component('faqs-component', require('./components/FaqsComponent').default);
app.component('plan-chooser-component', require('./components/PlanChooserComponent').default);
app.component('account-settings-overview-component', require('./components/AccountSettingsOverviewComponent').default);
app.component('profile-image-component', require('./components/ProfileImageComponent').default);
app.component('dashboard-calendar', require('./components/calendar/DashboardCalendar').default);
app.component('calendar-modal-component', require('./components/calendar/CalendarModalComponent.vue').default);
app.component('calendar-overview-component', require('./components/calendar/CalendarOverviewComponent.vue').default);
app.component('calendar-pending-list-component', require('./components/calendar/CalendarPendingListComponent').default);
app.component('quiz-component', require('./components/QuizComponent').default);

app.mount('#app');
